var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
//
var CookiesUtils = /** @class */ (function () {
    function CookiesUtils() {
    }
    CookiesUtils.CHUNK_SIZE = 1800;
    CookiesUtils.SECRET_KEY = 'INTERMAT_COOKIE_SECRET_KEY';
    CookiesUtils.encryptData = function (data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), CookiesUtils.SECRET_KEY).toString();
    };
    CookiesUtils.decryptData = function (encryptedData) {
        var bytes = CryptoJS.AES.decrypt(encryptedData, CookiesUtils.SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    };
    CookiesUtils.setEncryptedDataInCookies = function (key, data, options) {
        if (options === void 0) { options = {}; }
        var encryptedData = CookiesUtils.encryptData(data);
        var totalChunks = Math.ceil(encryptedData.length / CookiesUtils.CHUNK_SIZE);
        var defaultOptions = process.env.NODE_ENV === 'production' ? { secure: true, sameSite: 'Lax', path: '/' } : { path: '/' };
        for (var i = 0; i < totalChunks; i++) {
            var chunkKey = "".concat(key, "_part_").concat(i);
            var chunk = encryptedData.slice(i * CookiesUtils.CHUNK_SIZE, (i + 1) * CookiesUtils.CHUNK_SIZE);
            Cookies.set(chunkKey, chunk, __assign(__assign({}, defaultOptions), options));
        }
        Cookies.set("".concat(key, "_chunk_count"), totalChunks.toString(), __assign(__assign({ expires: 30 }, defaultOptions), options));
    };
    CookiesUtils.setEncryptedCookie = function (key, value, options) {
        if (options === void 0) { options = {}; }
        var encryptedValue = CookiesUtils.encryptData(value);
        var defaultOptions = process.env.NODE_ENV === 'production' ? { secure: true, sameSite: 'Lax', path: '/', expires: 90 } : { path: '/', expires: 90 };
        Cookies.set(key, encryptedValue, __assign(__assign({}, defaultOptions), options));
    };
    CookiesUtils.getDecryptedCookie = function (key) {
        var encryptedValue = Cookies.get(key);
        return encryptedValue ? CookiesUtils.decryptData(encryptedValue) : null;
    };
    CookiesUtils.getEncryptedDataFromCookies = function (key) {
        var chunkCount = Cookies.get("".concat(key, "_chunk_count"));
        if (!chunkCount) {
            return null;
        }
        var reconstructedData = '';
        for (var i = 0; i < parseInt(chunkCount, 10); i++) {
            var chunkKey = "".concat(key, "_part_").concat(i);
            var chunk = Cookies.get(chunkKey);
            if (chunk) {
                reconstructedData += chunk;
            }
            else {
                console.error("Falha ao recuperar a parte ".concat(i, " do cookie."));
                return null;
            }
        }
        try {
            return CookiesUtils.decryptData(reconstructedData);
        }
        catch (error) {
            console.error('Erro ao descriptografar os dados do cookie:', error);
            return null;
        }
    };
    CookiesUtils.removeEncryptedDataFromCookies = function (key) {
        var chunkCount = Cookies.get("".concat(key, "_chunk_count"));
        if (chunkCount) {
            for (var i = 0; i < parseInt(chunkCount, 10); i++) {
                Cookies.remove("".concat(key, "_part_").concat(i));
            }
            Cookies.remove("".concat(key, "_chunk_count"));
        }
    };
    CookiesUtils.get = function (key) {
        var encryptedValue = Cookies.get(key);
        return encryptedValue ? atob(encryptedValue) : undefined;
    };
    return CookiesUtils;
}());
export { CookiesUtils };
